'use strict';

import React from 'react';
import EventsTree from "./events-tree";
import {StatsStateProvider, useTree} from "./state";
import Chart from "./chart";
import Filter from "./filter";

function StatsPage() {
	const tree = useTree();
	if (!tree) {
		return <div id="cm-stats-page">Waiting for data</div>;
	}

	return (
		<div id="cm-stats-page">
			<StatsStateProvider>
				<h1 className="page-header">Stats</h1>
				<aside id="events-tree"><EventsTree tree={tree}/></aside>
				<section id="cm-stats-charts-section">
					<div id="cm-stats-filter"><Filter/></div>
					<div id="cm-stats-chart"><Chart/></div>
				</section>
			</StatsStateProvider>
		</div>
	);
}

export default StatsPage;